// Whether the scanner has ever started on this device.
//
// Inside the Capacitor shell the Permissions API is not a usable signal: a
// camera Android has already granted to the app still reads as 'prompt' or
// throws, so ScannerPage's auto-start branch never fires and the user taps
// "Start scanner" on every single visit. The OS grant is the real gate, and
// Capacitor answers the WebView's request from it without prompting again, so
// remembering one successful start is enough to skip the button afterwards.
//
// The first start stays behind the tap on purpose: that tap is what puts the
// Android camera dialog next to an explanation of why it is being asked.

const KEY = 'cameraStarted'

export function hasCameraStarted() {
  try {
    return localStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function markCameraStarted() {
  try {
    localStorage.setItem(KEY, '1')
  } catch {
    /* ignore */
  }
}
